<template>
  <!-- Teleport above .wrapper (z-index 1080) / sidebar (up to 1099) so full-page overlays
       are not clipped or covered by the sidebar (Summary Reports, datatables, etc.). -->
  <Teleport to="body" :disabled="!teleportToBody">
    <div
      v-show="isProcessing"
      class="loader-container"
      :class="[classes, { 'loader-container--body-portal': teleportToBody }]"
      :aria-busy="isProcessing ? 'true' : 'false'"
      :aria-hidden="isProcessing ? undefined : 'true'"
    >
      <CSpinner
        color="primary"
        id="cloader"
        aria-live="polite"
        aria-atomic="true"
        :aria-hidden="loaderText?.trim?.() ? 'true' : undefined"
        :visually-hidden-label="
          loaderText?.trim?.() ? undefined : accessibleLabel
        "
      />
      <div
        v-if="loaderText"
        class="loader-container__message"
        role="status"
        aria-live="polite"
        aria-atomic="true"
      >
        {{ loaderText }}
      </div>
    </div>
  </Teleport>
</template>

<script>
/* When `loaderText` is set, the message `role="status"` announces; spinner is decorative for AT. */
export default {
  name: "Loader",
  props: {
    isProcessing: {
      type: Boolean,
      default: false
    },
    classes: {
      type: String,
      default: ""
    },
    /** When true (default), render via Teleport to document.body so fixed overlay stacks above the sidebar. Set false for in-card loaders (e.g. position-absolute). */
    teleportToBody: {
      type: Boolean,
      default: true
    },
    loaderText: {
      type: String,
      default: ""
    }
  },
  computed: {
    accessibleLabel() {
      const custom = this.loaderText?.trim?.() || ""
      if (custom) return custom
      const t = this.$t
      if (typeof t === "function") {
        return t("common.a11y_loading")
      }
      /* Tests / mounts without vue-i18n */
      return "Loading"
    }
  }
}
</script>
<style>
#cloader {
  width: 4rem;
  height: 4rem;
}
</style>
